export type PainPointInsight = {
  index: string;
  title: string;
  body: string;
};

export type ConversionGapRow = {
  index: string;
  cause: string;
  impact: string;
  tone: "critical" | "resolve";
};

export const painPointIntro = {
  kicker: "增长正在换位置",
  title: "获客越来越贵，增长却卡在咨询之后",
  body: "客户触点越来越分散，决策周期越来越长。企业真正缺少的，不是更多回复，而是咨询发生后的连续推进能力。",
} as const;

export const painPointInsights: PainPointInsight[] = [
  {
    index: "01",
    title: "触点更碎",
    body: "客户在内容、广告、官网、社媒与私域之间切换。",
  },
  {
    index: "02",
    title: "决策更长",
    body: "客户反复比较、沉默、返回，不再沿单一漏斗前进。",
  },
  {
    index: "03",
    title: "回复不等于推进",
    body: "通用 AI 可以回答问题，却不会持续管理销售下一步。",
  },
];

export const conversionGap = {
  label: "The Conversion Gap",
  title: "真正的流失，发生在客户开口之后",
  footer: "3Chat 将每个断点连接成可执行、可评估、可持续优化的销售链路",
  rows: [
    {
      index: "01",
      cause: "高成本线索进入，黄金响应窗口开始缩短",
      impact: "流失倒计时开始",
      tone: "critical",
    },
    {
      index: "02",
      cause: "漏接、慢回或夜间无人接待",
      impact: "意向快速冷却",
      tone: "critical",
    },
    {
      index: "03",
      cause: "只回答问题，没有澄清真实需求",
      impact: "无法判断优先级",
      tone: "critical",
    },
    {
      index: "04",
      cause: "无法调用业务系统完成下一步",
      impact: "对话停在答案",
      tone: "critical",
    },
    {
      index: "05",
      cause: "客户沉默后，没有持续跟进",
      impact: "线索持续沉淀",
      tone: "critical",
    },
    {
      index: "06",
      cause: "只看最终结果，无法定位流失环节",
      impact: "策略无法学习",
      tone: "resolve",
    },
  ] satisfies ConversionGapRow[],
} as const;
